import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition = ({ children }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [animationDirection, setAnimationDirection] = useState('in');
  const [currentPath, setCurrentPath] = useState('');
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    
    // If it's the first load or same path, just fade in
    if (!currentPath) {
      setCurrentPath(path);
      setIsAnimating(true);
      setAnimationDirection('in');
      return;
    }

    // Only animate between login and register pages
    const isLoginToRegister = currentPath === '/login' && path === '/register';
    const isRegisterToLogin = currentPath === '/register' && path === '/login';
    
    if (isLoginToRegister || isRegisterToLogin) {
      // Professional slide animation for auth pages only
      setIsAnimating(true);
      setAnimationDirection('out');
      
      // After exit animation, change path and animate in
      setTimeout(() => {
        setCurrentPath(path);
        setAnimationDirection('in');
      }, 350);
      
      // Complete animation
      setTimeout(() => {
        setIsAnimating(false);
      }, 800);
    } else {
      // No animation for other routes - instant transition
      setCurrentPath(path);
      setIsAnimating(false);
    }
  }, [location.pathname, currentPath]);

  const getAnimationClass = () => {
    if (!isAnimating) return '';
    
    const isAuthTransition = (currentPath === '/login' && location.pathname === '/register') || 
                           (currentPath === '/register' && location.pathname === '/login');
    
    if (isAuthTransition) {
      // Professional slide animations for auth pages only
      if (animationDirection === 'out') {
        return location.pathname === '/register' 
          ? 'animate-page-slide-out-ultra' 
          : 'animate-page-slide-out-glow';
      } else {
        return location.pathname === '/register' 
          ? 'animate-page-slide-in-ultra' 
          : 'animate-page-slide-in-glow';
      }
    }
    
    // No animation class for other routes
    return '';
  };

  return (
    <div className={`page-transition-container ${getAnimationClass()}`}>
      {children}
    </div>
  );
};

export default PageTransition;
